import { render } from "./filtrosCheckbox.vue?vue&type=template&id=e800c5d4"
import script from "./filtrosCheckbox.vue?vue&type=script&lang=js"
export * from "./filtrosCheckbox.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__